import { SearchExportReportsResponse } from '@api';

export const getOptimisticReportExport = () => {
  const optimisticResult: SearchExportReportsResponse = {
    results: [
      {
        status: 'new',
        completedRows: 0,
        fileLocation: '',
        id: '',
        totalRows: 0,
      },
    ],
    page: 0,
    rows: 1,
    next: false,
  };

  return optimisticResult;
};
